import { warn } from 'helper/debug';

export type SequenceList = Array<string>;
export type SequenceState = 'SEQUENCE_INITIAL' | 'SEQUENCE_RUNNING' | 'SEQUENCE_FINISHED';

/*
 * Defined sequence states for usage
 * @type {Object}
 */
export const SequenceStates = {
	INITIAL: 'SEQUENCE_INITIAL',
	RUNNING: 'SEQUENCE_RUNNING',
	FINISHED: 'SEQUENCE_FINISHED',
};

/*
 * Valid sequences to define
 * @type {Array<SequenceState>}
 */
export const validSequenceStates = [SequenceStates.INITIAL, SequenceStates.RUNNING, SequenceStates.FINISHED];

/*
 * Check if a sequence state is in "loading" mode
 * @param {SequenceState} sequenceState
 */
export const transformSequenceStateToFlag = (sequenceState: SequenceState): boolean => {
	if (typeof sequenceState !== 'string' || !~validSequenceStates.indexOf(sequenceState)) {
		warn(
			`transformSequenceStateToFlag(...): Invalid sequence state given, allowed values: ${validSequenceStates.join(
				', '
			)}`
		);
	}

	return sequenceState === SequenceStates.RUNNING;
};
